import { render, staticRenderFns } from "./Scheme5.vue?vue&type=template&id=39da26ac&scoped=true"
import script from "./Scheme5.vue?vue&type=script&lang=js"
export * from "./Scheme5.vue?vue&type=script&lang=js"
import style0 from "./Scheme5.vue?vue&type=style&index=0&id=39da26ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da26ac",
  null
  
)

export default component.exports